module.exports = __webpack_public_path__ + "static/media/wrestling1.99b55f62.mov";